import { PREFERENCE, getLocalStoreSliceId } from 'store/store.constants';

import { MODE_SYSTEM } from 'components/ThemeProvider';
import { localStore } from 'utils/localStorage.utils';

export const getInitialState = () => ({
  appearance: MODE_SYSTEM,
  ...localStore.load(getLocalStoreSliceId(PREFERENCE)) ?? {},
});
